// Faq.js
'use client';
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';
import withRouter from '../component/WithRouter.jsx';
import { withTranslation } from 'react-i18next';

import Faq from '../component/Faq.jsx';
import getListData from '../selector/getListData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getNetworkingSummary from '../selector/getNetworkingSummary.js';
import fetchFaqArticles from '../action/fetchFaqArticles.js';
import { FAQ_SUPPORTED_LANGUAGES } from '../RemoteConfigKeys.js';
import { getCurrentFaqLanguage } from '../resource/getCurrentLanguage.js';

const mapStateToProps = (state, { i18n }) => {
  const faqSupportedLanguages = getRemoteConfigData(
    state,
    FAQ_SUPPORTED_LANGUAGES
  );
  const language = getCurrentFaqLanguage({
    i18n,
    supportedLanguages: faqSupportedLanguages,
  });

  const listSelectPath = ['faq', language];

  const nextPage = getListData(state, listSelectPath, 'nextPage');
  const isFetching = !!getNetworkingData(
    state,
    [...listSelectPath, nextPage],
    'isFetching'
  );
  const fetchFaqArticlesFirstPageStatus = getNetworkingSummary(state, [
    ...listSelectPath,
    1,
  ]);
  return {
    language,
    articleIds: getListData(state, listSelectPath, 'itemIds'),
    nextPage,
    isFetching,
    fetchFaqArticlesFirstPageStatus,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    goBack: () => dispatch(goBack()),
    fetchFaqArticles: ({ limit, page, language, httpProxyHeaders }) =>
      dispatch(fetchFaqArticles({ limit, page, language, httpProxyHeaders })),
  };
};

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Faq))
);
